import clsx from "clsx";

export interface CompressibleToolbarLabelProps {
  label: string;
  className?: string;
}

/**
 * Toolbar label that progressively truncates with a trailing ellipsis as the
 * available width shrinks (e.g. ``Mission: Long name`` → ``Mission: Lon…`` →
 * ``Miss…``). Relies on the parent flex item providing the shrinking width.
 */
export function CompressibleToolbarLabel({
  label,
  className,
}: CompressibleToolbarLabelProps) {
  return (
    <span className={clsx("block min-w-0 truncate", className)} title={label}>
      {label}
    </span>
  );
}
